import { IconButton, Tooltip } from '@mui/material';
import type { CellContext, DisplayColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';

import { campaignManagerTheme } from '@campaign-manager/theme';

export default function TableActionColumn<T>(
  props: DisplayColumnDef<T>,
  options: {
    onClick?: (row: T) => void;
    tooltip: string;
    icon: ReactNode;
    href?: string;
    hrefFn?: (row: T) => string;
    target?: string;
    ariaLabel?: string | ((row: T) => string);
  },
) {
  const { tooltip, icon, onClick, href, hrefFn, target, ariaLabel } = options || {};
  return {
    ...props,
    size: 0,
    cell: (cell: CellContext<T, any>) => (
      <Tooltip title={tooltip}>
        <IconButton
          component={hrefFn || href ? 'a' : 'button'}
          href={hrefFn ? hrefFn(cell.row.original) : href}
          target={target}
          onClick={onClick ? () => onClick?.(cell.row.original) : undefined}
          size="small"
          sx={{ backgroundColor: campaignManagerTheme.color.secondaryActionBg }}
          aria-label={typeof ariaLabel === 'function' ? ariaLabel(cell.row.original) : ariaLabel}
        >
          {icon}
        </IconButton>
      </Tooltip>
    ),
  };
}
